import { Calendar, Filter, Search, Download, FileText, Camera, Upload, Share } from "lucide-react"

export default function Prescriptions() {
  // Sample prescription data
  const prescriptions = [
    {
      id: 1,
      title: "Antibiotics Prescription",
      date: "10/10/2023",
      patient: "John Doe",
      doctor: "Dr. James Wilson",
      hospital: "City General Hospital",
    },
    {
      id: 2,
      title: "Pain Management",
      date: "9/5/2023",
      patient: "John Doe",
      doctor: "Dr. Emily Rodriguez",
      hospital: "Metro Medical Center",
    },
  ]

  // Function to render the brain icon directly
  const renderBrainIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="brain-icon"
    >
      <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
      <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
      <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
      <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
      <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
      <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
      <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
      <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
    </svg>
  )

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <FileText />
          <h1>Prescriptions</h1>
          <div className="title-actions">
            <button className="icon-action-button" title="Take Photo">
              <Camera size={20} />
            </button>
            <button className="icon-action-button" title="Upload Prescription">
              <Upload size={20} />
            </button>
          </div>
        </div>
      </div>

      <div className="search-container">
        <div className="search-input">
          <Search className="search-icon" />
          <input type="text" placeholder="Search documents..." />
        </div>
        <div className="filter-group">
          <button className="filter-button">
            <Filter />
            <span>Filter by Hospital</span>
          </button>
          <button className="filter-button">
            <Calendar />
            <span>Filter by Date</span>
          </button>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Prescription</th>
              <th>Date</th>
              <th>Patient Name</th>
              <th>Doctor Name</th>
              <th>Hospital</th>
              <th>Download</th>
              <th>AI Analysis</th>
              <th>Share</th>
            </tr>
          </thead>
          <tbody>
            {prescriptions.map((prescription) => (
              <tr key={prescription.id}>
                <td>{prescription.title}</td>
                <td>{prescription.date}</td>
                <td>{prescription.patient}</td>
                <td>{prescription.doctor}</td>
                <td>{prescription.hospital}</td>
                <td>
                  <Download className="action-icon" />
                </td>
                <td>
                  <button className="brain-button">{renderBrainIcon()}</button>
                </td>
                <td>
                  <button className="share-button">
                    <Share size={14} />
                    <span>Share</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

